import { TFunction } from '@lyearn/i18n';
import {
  Bold,
  CodeFill,
  Italic,
  Link2Outline,
  ListOutline,
  NumberedListOutline,
  QuoteOutline,
  Strikethrough,
  Underline,
} from '@lyearn/icons';

import { MarkType, MarkTypesEnum } from './types';

export const LAST_USED_COLOR_KEY = 'LastUsedColor';

// keep track, so that we don't spike mark type missing errors
export const markTypeErrorReported: Record<string, boolean> = {};
export class MarkNotFoundError extends Error {
  constructor(markName: string) {
    const message = `Mark ${markName} not found in schema`;
    super(message);
    this.message = message;
    this.name = 'MarkNotFoundError';
  }
}

export const SELECTION_MENU_BOTTOM_PADDING = 10;

export const marks = (t: TFunction) =>
  [
    {
      name: MarkTypesEnum.Bold,
      title: t('Common:Tooltips.Bold'),
      icon: Bold,
    },
    {
      name: MarkTypesEnum.Italic,
      title: t('Lygo:Italic'),
      icon: Italic,
    },
    {
      name: MarkTypesEnum.Underline,
      title: t('Common:Tooltips.Underline'),
      icon: Underline,
    },
    {
      name: MarkTypesEnum.Strikethrough,
      title: t('Common:Tooltips.Strikethrough'),
      icon: Strikethrough,
    },
    { name: MarkTypesEnum.Break, break: 'line' },
    {
      name: MarkTypesEnum.NumberedList,
      title: t('Common:Tooltips.NumberedList'),
      icon: NumberedListOutline,
      list: true,
    },
    {
      name: MarkTypesEnum.BulletList,
      title: t('Common:Tooltips.BulletedList'),
      icon: ListOutline,
      list: true,
    },
    {
      name: MarkTypesEnum.Blockquote,
      title: t('Common:Tooltips.Blockquote'),
      icon: QuoteOutline,
    },
    { name: MarkTypesEnum.Break, break: 'line' },
    {
      name: MarkTypesEnum.Code,
      title: t('Common:Tooltips.Code'),
      icon: CodeFill,
    },
    { name: MarkTypesEnum.Break, break: 'line' },
    {
      name: MarkTypesEnum.Link,
      title: t('Lygo:Link'),
      icon: Link2Outline,
    },
    { name: MarkTypesEnum.Break, break: 'line' },
    {
      name: MarkTypesEnum.Color,
      title: t('Lygo:Color'),
    },
  ] as MarkType[];

export const marksLocalizedContent = (t: TFunction) =>
  [
    {
      name: MarkTypesEnum.Bold,
      title: t('Common:Tooltips.Bold'),
      icon: Bold,
    },
    {
      name: MarkTypesEnum.Italic,
      title: t('Lygo:Italic'),
      icon: Italic,
    },
    {
      name: MarkTypesEnum.Underline,
      title: t('Common:Tooltips.Underline'),
      icon: Underline,
    },
    {
      name: MarkTypesEnum.Strikethrough,
      title: t('Common:Tooltips.Strikethrough'),
      icon: Strikethrough,
    },
    {
      name: MarkTypesEnum.Color,
      title: t('Lygo:Color'),
    },
  ] as MarkType[];
